import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "./LineGraph.scss";

const options = {
    maintainAspectRatio : false,
    responsive: true,
    spanGaps: true,
    clip: false,
    layout: {
      padding: {
        top: 15, left: 15, right: 15, bottom: 15
      }
    },
    scales: {
        x: {
          grid: {
            // display: false
            display: false
          },
        },
        y: {
          grid: {
            display: false
          },
          display: false //this will remove all the x-axis grid lines
        }
      },
      legend: {
        position: "top",
        align: "right",
        maxWidth: "30px",
        labels: {
            PointStyle: 'square',
            usePointStyle: true
          }
      },
      animation: {
        duration: 0
      },
      tooltips: {
        mode: 'index',
        intersect: false
     },
     interaction: {
      mode: 'nearest',
      // axis: 'x',
      intersect: false
    },
     hover: {
        // mode: 'index',
        // mode: 'index',
        intersect: false,
     },


}

export default function LineGraph(progress) {
  const data = {
    labels: [],
    datasets: [],
  };


  let weight=  {
    label: 'kg',
    data: [],
    borderColor: 'rgb(0, 185, 165)',
    backgroundColor: 'rgb(0, 185, 165)',
    pointWidth: 8,    
    pointRadius: 3,
    pointHoverRadius: 8,
    radius: 8,
    borderWidth: 4
  };
  let fat = {
      label: 'fat %',
      data: [],
      borderColor: 'rgb(255, 196, 21)',
      backgroundColor: 'rgb(255, 196, 21)',
      pointWidth: 8,      
      pointRadius: 3,
      pointHoverRadius: 8,
      radius: 8,
      borderWidth: 4
  };
  let bmi = {
      label: 'BMI',
      data: [],
      borderColor: 'rgb(157, 116, 173)',
      backgroundColor: 'rgb(157, 116, 173)',
      pointWidth: 8,      
      pointRadius: 3,
      pointHoverRadius: 8,
      radius: 8,
      borderWidth: 4
  };

  progress.progress && progress.progress.forEach(element => {
    let elementWeight = parseInt(element.weight);
    weight.data.push(elementWeight);
    let elementFat = parseInt(element.bodyfat);
    fat.data.push(elementFat);
    let elementBmi = parseInt(element.bmi);
    bmi.data.push(elementBmi);

    const milliseconds = element.time * 1000;
    const dateObject = new Date(milliseconds);
    const month = dateObject.getMonth()+1;
    //data.labels.push(dateObject.getDate() + "/" + month);
    data.labels.push(element.date);
  });

  data.datasets.push(weight);
  data.datasets.push(fat);
  data.datasets.push(bmi);

  return( 
      <div className="c-graph-wrapper" style={{ paddingTop: 20 }}>
          <Line options={options} data={data} />
      </div>
  );
}